export type QuickAddModule = 'core' | 'inventory' | 'crm' | 'service' | 'finance';

interface ModuleTheme {
  label: string;
  borderClass: string;
  bgClass: string;
  headerTextClass: string;
  iconTextClass: string;
}

// All class strings are literal — never construct with template strings.
// Tailwind's content scanner cannot see interpolated class names.
export const MODULE_THEME: Record<QuickAddModule, ModuleTheme> = {
  core: {
    label: 'Core',
    borderClass: 'border-violet-500',
    bgClass: 'bg-violet-50',
    headerTextClass: 'text-violet-700',
    iconTextClass: 'text-violet-500',
  },
  inventory: {
    label: 'Inventory',
    borderClass: 'border-lime-500',
    bgClass: 'bg-lime-50',
    headerTextClass: 'text-lime-700',
    iconTextClass: 'text-lime-500',
  },
  crm: {
    label: 'CRM',
    borderClass: 'border-teal-500',
    bgClass: 'bg-teal-50',
    headerTextClass: 'text-teal-700',
    iconTextClass: 'text-teal-500',
  },
  service: {
    label: 'Service',
    borderClass: 'border-blue-500',
    bgClass: 'bg-blue-50',
    headerTextClass: 'text-blue-700',
    iconTextClass: 'text-blue-500',
  },
  finance: {
    label: 'Finance',
    borderClass: 'border-yellow-500',
    bgClass: 'bg-yellow-50',
    headerTextClass: 'text-yellow-700',
    iconTextClass: 'text-yellow-500',
  },
};
